<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY</span><span class="smallcaps"><br/></span>R<span class="smallcaps">EBECCA </span>W<span class="smallcaps">AIT</span></h1>
<p class="center"><em class="italic">The View on the Way Down</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// thefollowers_00001.vue?0e5c4d2c